import * as React from 'react';
import DateRangeModal from "../../../../misc/components/queryTable/DateRangeModal";
import {
    Query,
    QueryCondition,
    QueryFilter,
    SpirometrySessionMetadata
} from "../../../../misc/api/apiTypes";

export const StartedAtFilterMember = "StartedDateTime";
export const StartedAtHeader = "Started At";

interface StartedAtFilterProps {
    onClose: (from: QueryFilter, to: QueryFilter) => void;
    query: Query<SpirometrySessionMetadata>;
}

const GetFromQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === StartedAtFilterMember && filter.Condition === QueryCondition.GreaterThanOrEqual);
}

const GetToQueryFilter = (query: Query<SpirometrySessionMetadata>): QueryFilter => {
    return query.Filters.find(filter => filter.Member === StartedAtFilterMember && filter.Condition === QueryCondition.LessThanOrEqual);
}

const StartedAtFilterModal = ({ onClose, query }: StartedAtFilterProps): JSX.Element => {

    const fromFilterValue = GetFromQueryFilter(query) || { Values: [] };
    const toFilterValue = GetToQueryFilter(query) || { Values: [] };

    const [from, setFrom] = React.useState<string>(fromFilterValue.Values[0]);
    const [to, setTo] = React.useState<string>(toFilterValue.Values[0]);

    return (<DateRangeModal
        header={StartedAtHeader + ' Filter'}
        show={true}
        to={to}
        from={from}
        onChange={(_from, _to) => {
            setFrom(_from);
            setTo(_to);
        }}
        onClose={() => {
            onClose({
                Member: StartedAtFilterMember,
                Condition: QueryCondition.GreaterThanOrEqual,
                Values: !!from ? [from] : []
            }, {
                    Member: StartedAtFilterMember,
                    Condition: QueryCondition.LessThanOrEqual,
                    Values: !!to ? [to] : []
                });
        }}
        onClear={() => {
            onClose({
                Member: StartedAtFilterMember,
                Condition: QueryCondition.GreaterThanOrEqual,
                Values: []
            }, {
                    Member: StartedAtFilterMember,
                    Condition: QueryCondition.LessThanOrEqual,
                    Values: []
                });
        }}
    />)
}

export default StartedAtFilterModal;
